export function exhaustiveArray<All extends PropertyKey>() {
  return <Arr extends readonly All[]>(
    arr: MissingFromArray<All, Arr> extends never ? Arr : never
  ) => arr;
}
